export enum AttachmentType {
  Folder = 'FOLDER',
  Task = 'TASK',
  StatusUpdate = 'STATUS_UPDATE',
}

export interface FileAttachmentRecord {
  associatedEntity?: {
    sourceType?: AttachmentType;
    sourceId: number;
  };
}

export interface FileAttachmentRequestBody extends FileAttachmentRecord {
  attachment: {
    projectId?: number;
    name: string;
    publicVisibility?: boolean;
  };
}
